export default {
    root:{
        padding: '20px 24px'
    }
}